module.exports = __webpack_public_path__ + "img/000.f21d9935.png";